import styled from 'styled-components';

export const Image = styled.img`
  max-width: 100%;
`;

export const VideoWrapper = styled.div`
  display: block;
  max-width: 100%;
  max-height: 500px;
  margin: 0 auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);

  &:after {
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    border: 1px solid #f8f8f8;
    border-right: 0;
    border-left: 0;
    background-color: transparent;
    pointer-events: none;
  }

  video,
  img {
    height: 100%;
    max-width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step2/styled.js